import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { forwardRef, useMemo } from "react";
import { FieldDescription } from "../field-description/FieldDescription";
import { FieldStatus } from "../field-status/FieldStatus";
import * as Styled from "./Fieldset.styled";
export const FieldsetContext = React.createContext({ disabled: false });
export const Fieldset = forwardRef((props, ref) => {
    /* istanbul ignore next */
    const { children, description, disabled, input, label, labelVariant, labelMaxWidth, labelWidth, required, status: statusProp, ...otherProps } = props;
    const contextValue = useMemo(() => ({ disabled: disabled || false }), [disabled]);
    const status = typeof statusProp === "string" ? { message: statusProp, level: "error" } : statusProp;
    return (_jsx(Styled.Fieldset, { ref: ref, "data-testid": "Fieldset", ...otherProps, disabled: disabled, children: _jsxs(FieldsetContext.Provider, { value: contextValue, children: [label && (_jsx(_Fragment, { children: _jsxs(Styled.Legend, { variant: labelVariant, maxWidth: labelMaxWidth, width: labelWidth, children: [required && _jsx(Styled.RequiredIndicator, { "aria-hidden": "true" }), label] }) })), input || children, description && _jsx(FieldDescription, { children: description }), _jsx(FieldStatus, { ...status })] }) }));
});
Fieldset.defaultProps = {
    labelVariant: "emphasized"
};
Fieldset.displayName = "Fieldset";
